import apiTrainer from '@/api/trainers'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  trainer: null
}

export const mutationTypes = {
  updateTrainerStart: '[update trainer] Update trainer start',
  updateTrainerSuccess: '[update trainer] Update trainer success',
  updateTrainerFailure: '[update trainer] Update trainer failure',

  getTrainerStart: '[update trainer] Get trainer start',
  getTrainerSuccess: '[update trainer] Get trainer success',
  getTrainerFailure: '[update trainer] Get trainer failure',

  resetPasswordStart: '[update trainer] resetPasswordStart',
  resetPasswordSuccess: '[update trainer] resetPasswordSuccess',
  resetPasswordFailure: '[update trainer] resetPasswordFailure'
}

export const actionTypes = {
  updateTrainer: '[update trainer] Update trainer',
  getTrainer: '[update trainer] Get trainer',
  resetPassword: '[update trainer] resetPassword'
}

const mutations = {
  [mutationTypes.updateTrainerStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateTrainerSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateTrainerFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getTrainerStart](state) {
    state.isLoading = true
    state.trainer = null
  },

  [mutationTypes.getTrainerSuccess](state, payload) {
    state.trainer = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainerFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.resetPasswordStart](state) {
    state.isSubmitting = true
  },
  [mutationTypes.resetPasswordSuccess](state) {
    state.isSubmitting = false
  },
  [mutationTypes.resetPasswordFailure](state, payload) {
    state.validationErrors = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.updateTrainer](context, {id, trainerInput}) {
    context.commit(mutationTypes.updateTrainerStart)
    return new Promise(resolve => {
      apiTrainer
        .updateTrainer(id, trainerInput)
        .then(response => {
          context.commit(mutationTypes.updateTrainerSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.updateTrainerFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getTrainer](context, {id}) {
    context.commit(mutationTypes.getTrainerStart)
    return new Promise(resolve => {
      apiTrainer
        .getTrainer(id)
        .then(response => {
          context.commit(mutationTypes.getTrainerSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainerFailure)
        })
    })
  },

  [actionTypes.resetPassword](context, {passwords}) {
    context.commit(mutationTypes.resetPasswordStart)
    return new Promise(resolve => {
      apiTrainer
        .resetPasswordTrainer(passwords)
        .then(user => {
          context.commit(mutationTypes.resetPasswordSuccess, user)
          resolve(user)
        })
        .catch(result => {
          context.commit(
            mutationTypes.resetPasswordFailure,
            result.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
